import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthComponentsModule as AuthComponentsModule} from './auth-components/auth-components.module';
import {RouterModule} from '@angular/router';
import {AuthRoutes} from './auth.routing';
import { MagicLinkComponent } from './magic-link/magic-link.component';


@NgModule({
  declarations: [
    MagicLinkComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(AuthRoutes),
    AuthComponentsModule
  ]
})
export class AuthModule {
}
